import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editor-background-type-modal-panel';

export default function PosterEditorBackgroundTypeModal(): ReactElement<any> {
  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });
  const panelProperties = useAppSelector((state) => {
    return state.panels.panelPropertiesHashmap[PANEL_ID];
  });

  const height = sizeData?.height?.length ? sizeData?.height : '224px';
  const width = '100%';

  return (
    <Modal
      doesBottomSheetHaveSnapPoints={panelProperties?.hasSnapPoints}
      snapPointsForBottomSheet={panelProperties?.snapPointsForBottomSheet}
      modalId={MODALS_IDS.POSTER_EDITOR_BACKGROUND_TYPE_MODAL}
      isBottomSheetOnMobile
      mobileHeight={height}
      panelId={PANEL_ID}
      modalHeight={height}
      modalWidth={width}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-background-type-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorBackgroundTypeModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_BACKGROUND_TYPE_MODAL,
      panelProps: {},
    })
  );
};
